function replaceMissingWishlistImages() {
  const fallbackGif = "no-image-2048";
  const svgUrl = "https://cdn.shopify.com/s/files/1/0770/3996/0277/files/placeholder-1.svg?v=1763992223";
  const imgs = document.querySelectorAll(
    ".wishlist-page .wishlist-column img, .wishlist-popup .wishlist-p-left img"
  );
  imgs.forEach((img) => {
    if (img.src.includes(fallbackGif) || img.src.includes("null")) {
      img.src = svgUrl;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(function () {
    replaceMissingWishlistImages();
    const bulk = document.querySelector(".bulk_action");
    const whHeader = document.querySelector(".headerwishlist");
    const hasItems = document.querySelector(".wishlist-page .wishlist-column");
    if (bulk && hasItems) {
      if (!document.querySelector("#move_to_cart_all_custom")) {
        const li = document.createElement("li");
        li.innerHTML = `
          <a href="javascript:void(0)" class="move_to_cart_all_custom" id="move_to_cart_all_custom">
            ADD ALL TO CART
          </a>
        `;
        bulk.appendChild(li);
      }
    }
    if(whHeader && hasItems){
      whHeader.classList.add('headShow');
    }
    document
      .querySelectorAll("#wishlist-page-contain input[type=checkbox]")
      .forEach((cb) => (cb.checked = true));
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
  replaceMissingWishlistImages();
});
function wishlistNotification(failedMessages) {
  document.querySelector('#wishlist-popup-custom')?.remove();

  const html = `
    <div class="wishlist-popup custom-popup" id="wishlist-popup-custom" data-position="top-left" style="position: fixed; top: 20px; left: 20px; background: #fff; transform:translateX(0); padding: 20px; border: 1px solid #ccc; z-index: 9999; box-shadow: 0 0 10px rgba(0,0,0,0.15); max-width: 300px;">
      <button class="close-wishlist" style="float: right; background: transparent; border: none; font-size: 20px; padding-left: 0 !important; text-transform: uppercase; cursor: pointer;">&times;</button>
      <div class="wishlit-popupinr">
        <div class="wishlist-p-right">
        ${failedMessages.length ? `
          <ul style="margin: 0; padding-left: 0px; padding-right: 5px; list-style-type: none; font-size: 11px; color: #191919; text-transform: uppercase;">
             ${failedMessages.map(msg => `<li>${msg.title}</li>`).join('')}
          </ul>` : ` 
          <h4 style="margin: 0 0 10px;font-size: 11px; color: #191919; text-transform: uppercase;">All items added to cart</h4>
          `}
        </div>
      </div>
    </div>
  `;

  document.body.insertAdjacentHTML('beforeend', html);
  setTimeout(() => {
    document.querySelector('#wishlist-popup-custom')?.remove();
  }, 3000);
  document.querySelector('#wishlist-popup-custom .close-wishlist')?.addEventListener('click', () => {
    document.querySelector('#wishlist-popup-custom')?.remove();
  });
}

document.addEventListener('click', async function (event) {
  const target = event.target.matches('#move_to_cart_all_custom')
    ? event.target
    : event.target.closest('#move_to_cart_all_custom');

  if (!target) return;
  event.preventDefault();

  target.classList.add("loading");

  const failedItems = [];
  const parent = target.closest('.wishlist-container');
  const IDs = [];

  const allWishlistColumns = parent.querySelectorAll('.wishlist-column');

  allWishlistColumns.forEach((wishlistItem) => {
    const droplist = wishlistItem.querySelector('.wishlist_droplist');

    if (!droplist) return;

    const variantPicker = droplist.querySelector('.wishlist-variant-picker');
    const titleElement = wishlistItem.querySelector('.wh-pro-meta h3 a');

    let productTitle = titleElement?.textContent.trim() || "Product";

    if (variantPicker) {
      const selectedOption = variantPicker.querySelector('option:checked');

      if (selectedOption) {
        const inventory = parseInt(selectedOption.getAttribute('data-inventory_quantity')) || 0;
        const variantId = selectedOption.value;
        const variantTitle = selectedOption.getAttribute('data-title') || selectedOption.textContent.trim();

        if (inventory > 0) {
          IDs.push(variantId);
        } else {
          failedItems.push({
            id: variantId,
            title: `${productTitle} - ${variantTitle} (Out of Stock)`
          });
        }
      }
    } else {
      const inventory = parseInt(droplist.getAttribute('data-inventory_quantity')) || 0;
      const variantId = droplist.getAttribute('data-variant_id');

      if (variantId) {
        if (inventory > 0) {
          IDs.push(variantId);
        } else {
          failedItems.push({
            id: variantId,
            title: `${productTitle} (Out of Stock)`
          });
        }
      }
    }
  });
  if (IDs.length) {
    window.AddAlltoCartDrawer(IDs);
  }

  target.classList.remove("loading");
  document.querySelector('#delete_all')?.click();
  document.body.classList.remove('wishlist');
  wishlistNotification(failedItems);
});

window.AddAlltoCartDrawer = function (IDs) {
  if (!Array.isArray(IDs) || IDs.length === 0) {
    console.warn("No matching variant IDs found.");
    return;
  }

  function getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector)?.innerHTML || "";
  }

  const sectionsToRender = [
    { id: "CartDrawer", section: "cart-drawer", selector: ".drawer__inner" },
    { id: "cartIconBubble", section: "cart-icon-bubble", selector: ".cart-count-section" },
  ];

  const formData = new FormData();
  IDs.forEach((variantId, index) => {
    formData.append(`items[${index}][id]`, variantId);
    formData.append(`items[${index}][quantity]`, 1);
  });

  formData.append("sections", sectionsToRender.map((s) => s.section));
  formData.append("sections_url", window.location.pathname);

  const config = {
    method: "POST",
    headers: { "X-Requested-With": "XMLHttpRequest" },
    body: formData,
  };

  document.querySelector("cart-drawer")?.classList.add("loading");

  fetch(`/cart/add.js`, config)
    .then((res) => res.json())
    .then((addResponse) => {
      if (addResponse.status) {
        console.error("Add to cart error:", addResponse.description);
        throw new Error(addResponse.description);
      }
      return fetch('/cart.js', {
        method: 'GET',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
    .then((res) => res.json())
    .then((cartData) => {
      console.log('Updated cart data:', cartData);
      document.querySelector("cart-drawer")?.classList.remove("is-empty");
      document.querySelector("cart-drawer")?.classList.add("active");
      return fetch(`/cart?sections=${sectionsToRender.map(s => s.section).join(',')}`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
    })
    .then((res) => res.json())
    .then((response) => {
      sectionsToRender.forEach((section) => {
        const element = section.selector 
          ? document.querySelector(section.selector) 
          : document.getElementById(section.id);
        
        if (element && response[section.section]) {
          element.innerHTML = getSectionInnerHTML(
            response[section.section],
            section.selector
          );
        }
      });
    })
    .catch((error) => {
      console.error("Cart operation error:", error);
    })
    .finally(() => {
      document.querySelector("cart-drawer")?.classList.remove("loading");
    });
};
// ====================================
let wishlistInitialized = false;

function extractHandle(url) {
  try {
    const parts = url.split("/products/");
    if (parts[1]) return parts[1].split("?")[0].replace("/", "");
  } catch (e) {
    console.error("Handle extraction failed:", e);
  }
  return null;
}

async function showProduct(handle) {
  try {
    if (document.querySelector(`[data-handle="${handle}"]`)) return;
    
    const response = await fetch(`/products/${handle}?section_id=product-popup`);
    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    const popup = doc.querySelector('.product-popup-modal-overlay');
    
    if (!popup) {
      console.warn("Popup not found for:", handle);
      return;
    }
    
    document.body.insertAdjacentHTML("beforeend", popup.outerHTML);
    
  } catch (error) {
    console.error("Error loading popup for handle:", handle, error);
  }
}

function updateWishlistInventory() {
  const wishlistItems = document.querySelectorAll(".wishlist-column");
  wishlistItems.forEach(item => {
    const link = item.querySelector(".wihslist-meta h3 a");
    if (!link) return;
    
    let handle = extractHandle(link.href);
    if (!handle) return;
    handle = decodeURIComponent(handle);

    const popup = document.querySelector(`.product-popup-modal-overlay[data-handle="${handle}"]`);
    if (!popup) return;

    const inv = popup.querySelector('.data-inventory');
    if (!inv) return;

    const qty = inv.getAttribute('data-inventory');
    const variantId = inv.getAttribute('data-variant_id');

    const wishlistDrop = item.querySelector('.wishlist_droplist');
    if (!wishlistDrop) return;

    wishlistDrop.setAttribute('data-inventory_quantity', qty);

    wishlistDrop.querySelectorAll('option').forEach(o => {
      if (o.value === variantId) {
        o.setAttribute('data-inventory_quantity', qty);
      }
    });
  });
}


async function wishlistFunc() {
  const links = document.querySelectorAll(".wihslist-meta h3 a");
  if (links.length === 0) return;

  if (!wishlistInitialized) {
    wishlistInitialized = true;

    const handles = [];
    links.forEach(link => {
      let handle = extractHandle(link.href);
      if (handle) handles.push(decodeURIComponent(handle));
    });

    await Promise.all(handles.map(handle => showProduct(handle)));
  }

  setTimeout(() => {
    updateWishlistInventory();
  }, 150);
}

document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    wishlistFunc();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});